module.exports = __webpack_public_path__ + "img/executor.8f31c923.svg";